<template>
	<div class="employer-container">

		<div class="row page-heading">
			<div class="col-7 input module_heading">
				<div class="module_icon ico-employer"></div>
				<label class="head_txt module_type_name">{{employer.title}}</label>
			</div>
			<div class="col-5 float-right px-0">
				<div class="btn-container">
          <!--
					<span class="icon-channel"></span>
					<button class="btn"><span>share</span><span class="icon-share2"></span></button>
					<button class="btn">upload jobs</button>
          -->
				</div>
			</div>
		</div>


		<div class="page-content-section row">


			<div class="left-side">
	          	<employer-menu :uuid="uuid" active="home"></employer-menu>
	        </div>

        	<div class="right-panel">

        		<div class="right-nav">Opportunities</div>

				<div class="content-row">
          <!--
					<p>Sed tristique, est vel ornare iaculis, diam metus maximus nisl, id convallis tortor leo sit amet ipsum. Vivamus sit amet felis at quam mollis
						ullamcorper. Etiam non convallis arcu, et luctus tortor. Ut non leo vitae eros eleifend euismod. Nulla facilisi. Donec auctor et arcu vitae
						tempus. Ut volutpat scelerisque aliquet. Quisque vestibulum eleifend nibh, a congue nisl consectetur a. Curabitur lobortis, libero a lacinia
						rhoncus, lectus quam lobortis ex, eget pharetra purus mi faucibus eros.
					</p>
        -->
					<div class="subheading">
						{{categoryTitle}}
					</div>

					<div class="list-section">
						<div class="list-row">

							<div v-for="job in jobs">

								<div class="job_row">
									<div class="title-row" style="margin-bottom: 0px;">
										<!--
										<div class="form-field">
											<input type="checkbox">
										</div>
										-->
										<div class="list-title" style="float: left; width: 100%; margin-bottom: 0px;">
											<span class="icon icon-job"></span>
											<span class="title-name" style="margin: -9px 5px 0px 10px;">
												<job-result :title="job.title" :uuid="job.uuid"></job-result>
											</span>
											<!--<span class="icon-channel container-right"></span>-->
										</div>
									</div>
									<div class="description">
										<job-result :description="job.description"></job-result>
									</div>

									<div class="row column-row url-row" v-if="job.externalLink">
										<div class="col-12 column-content">
											<span class="icon-link col-left"></span>
											<span class="col-right long_url"><b-link :href="job.externalLink" target="_blank" :title="job.externalLink">{{job.externalLink}}</b-link></span>
										</div>
									</div>
								</div>

							</div>
						</div>
					</div>

				</div>

        	</div>


		</div>




  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import EmployerMenu from './EmployerMenu'
import JobResult from './JobResult'

export default {
  name: 'employerHome',
  props: ['uuid', 'category'],
  components: {
    EmployerMenu,
    JobResult
  },
  data: () => {
    return {
      categoryTitle: '',
      jobs: []
    }
  },

  mounted () {
    this.loadEmployerCategory()
  },

  updated () {
  },

  methods: {
    ...mapActions([
      'loadEmployerDetail',
      'loadAllJobs'
    ]),

    loadEmployerCategory () {
      this.loadEmployerDetail(this.uuid)
      this.loadAllJobs(this.uuid).then(res => {
        for (const [key, value] of Object.entries(this.categories)) {
        // for((value, key) in this.categories) {
          if (key === this.category) {
            this.categoryTitle = key
            this.jobs = value
          }
        }
      })
    }

  },

  computed: {
    ...mapState({
      'employer': state => state.employer.employer,
      'categories': state => state.employer.categories
    })
  },

  watch: {
    category (newCat) {
      console.log('this is being called')
      this.loadEmployerCategory()
    }
  }
}
</script>
<style>
.margin-top-10 {
  margin-top: 10px;
}
.margin-top-20 {
  margin-top: 20px;
}
.margin-top-30 {
  margin-top: 30px;
}
.no-border {
  border: none;
}
.margin-left-20 {
  margin-left: 20px;
}
</style>



// WEBPACK FOOTER //
// src/app/employer/components/EmployerCategory.vue